import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// AOS
import AOS from "aos";
import "aos/dist/aos.css";

// Components
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";

import Home from "./component/Home";
import About from "./component/About";
import Tours from "./component/Tours";
import ContactUS from "./component/ContactUS";

import DayTours from "./component/DayTours";
import GalleDayTour from "./component/DayTour/GalleDayTour";
import KandyDayTour from "./component/DayTour/KandyDayTour";
import UdawalaweDayTour from "./component/DayTour/UdawalaweDayTour";
import YalaDayTour from "./component/DayTour/YalaDayTour";
import SigiriyaDambullaDayTour from "./component/DayTour/SigiriyaAndDambullaDayTour";
import WhaleWatchingMirissa from "./component/DayTour/WhaleWatchingDayTour";
import PinnawalaElephantTour from "./component/DayTour/PinnawalaElephantTour";

import KithulgalaRafting from "./component/DayTour/KitulgalaRaftingTour";
import SinharajaDayTour from "./component/DayTour/SinharajaRainforestTrek";
import BentotaFishing from "./component/DayTour/BentotaDeepSeaFishing";

import RoundTours from "./component/RoundTours";
import KandySigiriyaDambullaTour from "./component/Rounded/KandySigiriyaDambullaTour";
import UdawalaweYalaTwoDayTour from "./component/Rounded/UdawalaweYalaTwoDayTour";
import YalaSafariGalleOvernightTwoDayTour from "./component/Rounded/YalaSafariGalleOvernightTwoDayTour";
import FourDaySriLankaTour from "./component/Rounded/FourDaySriLankaTour";
import SriLankaDiscoveryTour from "./component/Rounded/SriLankaDiscoveryTour";
import EpicSriLankaTour from "./component/Rounded/EpicSriLankaTour";
import SummerTour from "./component/Rounded/SummerTour";

import Gallery from "./component/Gallery";
import GalleryPreview from "./component/GalleryPreview";
import AlbertoGallery from "./component/AlbertoGallery";

// ScrollToTop component to refresh AOS and scroll
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // scroll to top
        AOS.refresh();          // refresh AOS animations
    }, [pathname]);

    return null;
}

function App() {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1200,
            once: true,
        });
    }, []);

    return (
        <BrowserRouter>
            <Navbar />
            <ScrollToTop />

            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/tours" element={<Tours />} />
                <Route path="/tours/day-tours" element={<DayTours />} />
                <Route path="/tours/day-tours/galle-day-tour" element={<GalleDayTour />} />
                <Route path="/tours/day-tours/kandy-day-tour" element={<KandyDayTour />} />
                <Route path="/tours/day-tours/udawalawe-day-tour" element={<UdawalaweDayTour />} />
                <Route path="/tours/day-tours/yala-day-tour" element={<YalaDayTour />} />
                <Route path="/tours/day-tours/sigiriya-dambulla-day-tour" element={<SigiriyaDambullaDayTour />} />
                <Route path="/tours/day-tours/whale-watching-mirissa" element={<WhaleWatchingMirissa />} />
                <Route path="/tours/day-tours/pinnawala-elephant" element={<PinnawalaElephantTour />} />
                <Route path="/tours/day-tours/kithulgala-rafting" element={<KithulgalaRafting />} />
                <Route path="/tours/day-tours/sinharaja-day-tour" element={<SinharajaDayTour />} />
                <Route path="/tours/day-tours/bentota-fishing" element={<BentotaFishing />} />

                <Route path="/contact" element={<ContactUS />} />

                <Route path="/tours/round-tours" element={<RoundTours />} />
                <Route path="/tours/round-tours/kandy-sigiriya-dambulla" element={<KandySigiriyaDambullaTour />} />
                <Route path="/tours/round-tours/udawalawe-yala" element={<UdawalaweYalaTwoDayTour />} />
                <Route path="/tours/round-tours/yala-galle" element={<YalaSafariGalleOvernightTwoDayTour />} />
                <Route path="/tours/round-tours/kandy-ella-yala" element={<FourDaySriLankaTour />} />
                <Route path="/tours/round-tours/sri-lanka-discovery-tour" element={<SriLankaDiscoveryTour />} />
                <Route path="/tours/round-tours/epic-lanka-tour" element={<EpicSriLankaTour />} />
                <Route path="/tours/round-tours/summer-tour" element={<SummerTour />} />

                <Route path="/gallery" element={<Gallery />} />
                <Route path="/gallery-preview" element={<GalleryPreview />} />
                <Route path="/alberto" element={<AlbertoGallery />} />
            </Routes>

            <Footer />
        </BrowserRouter>
    );
}

export default App;
